import {
    Badge,
    Box,
    Button,
    Flex,
    Grid,
    Group,
    Input,
    Menu,
    MultiSelect,
    MultiSelectProps,
    rem,
    Select,
    Text,
} from "@mantine/core";
import {
    IconBarcode,
    IconBuildingWarehouse,
    IconCaretDown,
    IconFileExport,
    IconMapPin,
    IconPackage,
    IconRulerMeasure,
    IconSearch,
    IconTimeDuration15,
    IconX,
} from "@tabler/icons-react";
import {
    MRT_ColumnDef,
    MRT_PaginationState,
    MRT_RowSelectionState,
    MantineReactTable,
    useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { useForm } from "@mantine/form";
import { useDebouncedCallback, useDisclosure } from "@mantine/hooks";
import { SelectListItemModel } from "../../../../model/SelectListItem";
import { BASE_API_MDM } from "../../../../config";
import { green } from "../../../../const/variables";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
    repositoryMdm,
    repositoryPos,
    styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import {
    formatDateNotTimeZone,
    formatDateTransfer,
    formatDateTransferLastYear,
    formatToReverseDate,
} from "../../../../common/FormatDate/FormatDate";
import { DatePickerInput } from "@mantine/dates";
import { IconBriefcase } from "@tabler/icons-react";
import { MessageResponse } from "../../../../model/MessageResponse";
import { ComboboxItem } from "../../../../model/ComboboxItem";
import { IconBuildingFactory } from "@tabler/icons-react";
import { IconFolders } from "@tabler/icons-react";
interface SearchCriteria {
    keySearch?: string;
    branchCode?: string[]; // Mảng chứa các mã chi nhánh
    invCode?: string[]; // Mảng chứa các mã kho
    itemCode?: string[]; // Mảng chứa các mã sản phẩm
    itemKey?: string; // Mã sản phẩm hoặc khóa sản phẩm
    MaNganh?: string;
    MaLoai?: string;
    MaNhom?: string;
    MaHangSx?: string;
    FromDate?: Date | string;
    ToDate?: Date | string;
    FromTuoiTon?: number;
    ToTuoiTon?: number;
}

const InventoryAge = () => {
    // Khởi tạo component InventoryReportList
    const headerRef = React.useRef<HTMLDivElement>(null);
    const [isRefetching, setIsRefetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 20,
    });
    const [visible, { toggle, close, open }] = useDisclosure(false);

    const [height, setHeight] = useState(0);
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
    const [data, setData] = useState<InventoryItem[]>([]);
    const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
    const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
    const [rowCount, setRowCount] = useState(0);
    const [dataCatSegment2b, setDataCatSegment2b] = useState<any[]>([]);
    const [dataCatSegment3c, setDataCatSegment3c] = useState<any[]>([]);
    const [dataCatSegment5e, setDataCatSegment5e] = useState<any[]>([]);
    const [dataBrand, setDataBrand] = useState<any[]>([]);
    const form = useForm<SearchCriteria>({
        mode: "uncontrolled",
        initialValues: {},
    });

    type InventoryItem = {
        branchCode: string;
        branchName: string;
        countSoLuong: number;
        dvt: string | null;
        idBranch: number;
        idKho: number;
        maKho: string;
        maSp: string;
        soLuong: number | null;
        tenKho: string;
        tenSp: string;
    };

    const columns = React.useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                header: "STT",
                accessorKey: "STT",
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                Cell: ({ row }) => <>{row?.index + 1}</>,
                size: 50,
            },
            {
                accessorKey: "maSp",
                header: "Mã sản phẩm",
                Cell: ({ renderedCellValue, cell, row }) => (
                    <>
                        <Badge
                            radius="sm"
                            variant="dot"
                            size="md"
                            style={{ cursor: "pointer" }}
                            color={renderedCellValue === null ? "red" : green.base}
                        >
                            {renderedCellValue ?? "Không có mã sản phẩm"}
                        </Badge>
                    </>
                ),
            },
            {
                accessorKey: "tenSp",
                header: "Tên sản phẩm",
                size: 300,
            },
            {
                accessorKey: "maCn",
                header: "Mã chi nhánh",
                size: 150,
                Cell: ({ renderedCellValue, cell, row }) => (
                    <>
                        <Badge variant="light" color="violet">
                            {renderedCellValue}
                        </Badge>
                    </>
                ),
            },
            {
                accessorKey: "serial",
                header: "Số serial",
                size: 150,
                Cell: ({ renderedCellValue, cell, row }) => (
                    <>
                        <Badge variant="light" color="violet">
                            {renderedCellValue}
                        </Badge>
                    </>
                ),
            },
            {
                accessorKey: "maKho",
                header: "Mã kho",
                size: 150,
                Cell: ({ renderedCellValue, cell, row }) => (
                    <>
                        <Badge variant="light" color="blue">
                            {renderedCellValue}
                        </Badge>
                    </>
                ),
            },
            {
                accessorKey: "maNganh",
                header: "Mã ngành",
            },
            {
                accessorKey: "maLoai",
                header: "Mã loại",
            },
            {
                accessorKey: "maNhom",
                header: "Mã nhóm",
            },
            {
                accessorKey: "maHangSx",
                header: "Mã hàng SX",
            },
            {
                accessorKey: "tuoiTon",
                header: "Tuổi tồn",
            },
            {
                accessorKey: "ngayNhap",
                header: "Ngày nhập",
                Cell: ({ renderedCellValue }: any) => (
                    <>{formatDateTransfer(renderedCellValue)}</>
                ),
            },
        ],
        []
    );
    const exportDataExcel = async () => {
        open();
        try {
            let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
            const search = form.getValues();
            if (search.branchCode && search.branchCode.length > 0) {
                search.branchCode.forEach((branchCode) => {
                    url += `&MaCn=${branchCode}`;
                });
            }
            if (search.invCode) {
                url += `&MaKho=${search.invCode}`;
            }
            if (search.itemCode) {
                url += `&MaSp=${search.itemCode}`;
            }

            if (search.keySearch) {
                url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
            }
            if (search.MaNganh) {
                url += `&MaNganh=${search.MaNganh}`;
            }
            if (search.MaLoai) {
                url += `&MaLoai=${search.MaLoai}`;
            }
            if (search.MaNhom) {
                url += `&MaNhom=${search.MaNhom}`;
            }
            if (search.MaHangSx) {
                url += `&MaHangSx=${search.MaHangSx}`;
            }
            if (search.ToDate) {
                const formattedToDate =
                    search.ToDate instanceof Date
                        ? formatToReverseDate(search.ToDate)
                        : search.ToDate;
                url += `&ToDate=${formattedToDate}`;
            }
            if (search.FromDate) {
                const formattedFromDate =
                    search.FromDate instanceof Date
                        ? formatToReverseDate(search.FromDate)
                        : search.FromDate;
                url += `&FromDate=${formattedFromDate}`;
            }
            if (search.ToTuoiTon) {
                url += `&ToTuoiTon=${search.ToTuoiTon}`;
            }
            if (search.FromTuoiTon) {
                url += `&FromTuoiTon=${search.FromTuoiTon}`;
            }
            // const baseUrl = `https://apis-pos-dev.hacom.vn/api-shipping/api/v1/ExportExcel/export-inventory-report${url}`;
            // // const baseUrl = `/api/v1/ExportExcel/export-inventory-report${url}`;
            // const fileName = "bao_cao_ton_kho.xlsx";

            // await exportDataToExcel(baseUrl, fileName);
            const baseUrl = `/api/v1/ExportExcel/export-bao-cao-tuoi-ton${url}`;

            const _url = BASE_API_MDM + baseUrl;
            const token = localStorage.getItem("token");

            const response = await fetch(_url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.ms-excel",
                    Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
                },
            });
            // Kiểm tra trạng thái HTTP
            if (!response.ok) {
                const errorResponse = await response.json(); // Parse lỗi từ API
                const errorMessage =
                    errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
                throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
            }

            const blob = await response.blob();
            const urlss = window.URL.createObjectURL(blob);
            const _name = new Date().toISOString().slice(0, 10);
            let filename = "bao_cao_tuoi_ton.xlsx";
            const link = document.createElement("a");
            link.href = urlss;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error: any) {
            console.log("error", error);
            // Hiển thị thông báo lỗi
            NotificationExtension.Fails(
                error.message || "Đã xảy ra lỗi không xác định!"
            );
        } finally {
            close();
        }
    };
    // Hàm lấy dữ liệu
    const fetchData = async () => {
        setIsLoading(true);
        setIsRefetching(true);
        setIsError(false);

        let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
            }`;
        const search = form.getValues();

        if (search.branchCode && search.branchCode.length > 0) {
            search.branchCode.forEach((branchCode) => {
                url += `&MaCn=${branchCode}`;
            });
        }
        if (search.invCode) {
            url += `&MaKho=${search.invCode}`;
        }
        if (search.itemCode) {
            url += `&MaSp=${search.itemCode}`;
        }

        if (search.keySearch) {
            url += `&KeySearch=${search.keySearch}`;
        }
        if (search.MaNganh) {
            url += `&MaNganh=${search.MaNganh}`;
        }
        if (search.MaLoai) {
            url += `&MaLoai=${search.MaLoai}`;
        }
        if (search.MaNhom) {
            url += `&MaNhom=${search.MaNhom}`;
        }
        if (search.MaHangSx) {
            url += `&MaHangSx=${search.MaHangSx}`;
        }
        if (search.ToDate) {
            const formattedToDate =
                search.ToDate instanceof Date
                    ? formatToReverseDate(search.ToDate)
                    : search.ToDate;
            url += `&ToDate=${formattedToDate}`;
        }
        if (search.FromDate) {
            const formattedFromDate =
                search.FromDate instanceof Date
                    ? formatToReverseDate(search.FromDate)
                    : search.FromDate;
            url += `&FromDate=${formattedFromDate}`;
        }
        if (search.ToTuoiTon) {
            url += `&ToTuoiTon=${search.ToTuoiTon}`;
        }
        if (search.FromTuoiTon) {
            url += `&FromTuoiTon=${search.FromTuoiTon}`;
        }
        try {
            const response = await repositoryMdm.get(
                `/api/v1/BaoCaoTuoiTon/get-list${url}`
            );
            if (response && response.success) {
                let result = response.data;
                setData(result);
                setRowCount(response.totalCount);
                table.resetRowSelection();
            } else {
                setData([]);
                setRowCount(response.totalCount);
            }
        } catch (error) {
            setData([]);
            setIsError(true);
            console.error(error);
            return;
        } finally {
            setIsLoading(false);
            setIsRefetching(false);
        }
    };

    const DataInvCode = async () => {
        try {
            const response = await repositoryPos.get(
                `/api/v1/TblDmInventory/get-all?checkAuth=true&select=true`
            );
            if (response && response.success) {
                const transformedData = response.data
                    ?.filter((i: any) => i.value && i.text && i.value !== "-1")
                    ?.map((item: any) => ({
                        label: item.text?.toString(),
                        value: item.att1?.toString(),
                    }));

                setDataInvCode(transformedData);
            }
        } catch (error) {
            console.error(error);
            return;
        }
    };
    const fetchDataCatSegment2b = async () => {
        const res = await repositoryPos.get<MessageResponse<any>>(
            "/api/v1/TblCatSegment2b/get-all"
        );

        if (res && res.success) {
            let data: ComboboxItem[] = [];
            data = res.data
                ?.filter(
                    (item: any) => item.codeString && item.name && item.segment1CodeString
                )
                ?.map((item: any) => ({
                    label: `${item.codeString} - ${item.name}`,
                    value: item.codeString?.toString(),
                    segment1CodeString: item.segment1CodeString?.toString(),
                }));

            setDataCatSegment2b(data);
        }
    };
    const fetchDataCatSegment3c = async () => {
        const res = await repositoryPos.get<MessageResponse<any>>(
            "/api/v1/TblCatSegment3c/get-all"
        );

        if (res && res.success) {
            let data: ComboboxItem[] = [];
            data = res.data
                ?.filter(
                    (item: any) => item.codeString && item.name && item.segment2CodeString
                )
                ?.map((item: any) => ({
                    label: `${item.codeString} - ${item.name}`,
                    value: item.codeString?.toString(),
                    segment2CodeString: item.segment2CodeString?.toString(),
                }));

            setDataCatSegment3c(data);
        }
    };
    const getCatSegment5e = async () => {
        let url = `/api/v1/TblCatSegment5e/get-list?Skip=0&Take=50`;
        const res = await repositoryPos.get<MessageResponse<any>>(url);
        if (res && res.success) {
            const data = res.data
                ?.filter((item: any) => item.codeString && item.name)
                ?.map((item: any) => ({
                    label: `${item.codeString} - ${item.name}`,
                    value: item.codeString?.toString(),
                }));

            setDataCatSegment5e(data);
        }
    };
    const fetchDataBrand = async () => {
        const res = await repositoryPos.get<MessageResponse<any>>(
            "/api/v1/TblDmBrand/get-all"
        );

        if (res && res?.success) {
            const dataAPI = res?.data
                ?.filter((item: any) => item.text !== null && item.att1 !== null)
                ?.map((item: any) => ({
                    label: item.text,
                    value: item.text?.toString(),
                }));
            setDataBrand(dataAPI);
        }
    };
    const DataItemCode = async (keySearch: string) => {
        try {
            let url = "";
            if (keySearch && keySearch.length > 0) {
                url += `&ItemCodes=${keySearch}`;
            }
            const response = await repositoryPos.get(
                `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`
            );
            if (response && response.success) {
                const transformedData = response.data
                    ?.filter((i: any) => i.value && i.text)
                    .map((branch: any) => ({
                        value: branch.value,
                        label: branch.text,
                    }));
                const uniqueData = Array.from(
                    new Set(transformedData.map((item: any) => item.value))
                ).map((value) =>
                    transformedData.find((item: any) => item.value === value)
                );
                setDataItemCode(uniqueData);
            }
        } catch (error) {
            console.error(error);
            return;
        }
    };

    const table = useMantineReactTable({
        columns,
        data,
        enableColumnResizing: true,
        rowCount,
        enableColumnFilters: true,
        enableSorting: true,
        enableColumnActions: true,
        // manualPagination: true,
        enableStickyFooter: true,
        state: {
            // columnFilters,
            // globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            showSkeletons: isLoading,
            rowSelection,
        },
        manualFiltering: false,
        manualPagination: true,
        manualSorting: false,
        onPaginationChange: setPagination,
        positionToolbarAlertBanner: "bottom",
        initialState: {
            showColumnFilters: false,
            columnPinning: {
                left: ["STT", "maSp", "transactionNumber", "sourceCode"],
                right: [
                    "statusName",
                    "countSoLuong",
                    "countSlChoXuat",
                    "countSlChoNhap",
                ],
            },
            columnVisibility: { id: false },
            density: "xs",
        },
        enableTopToolbar: false,
        mantineTopToolbarProps: {
            style: {
                borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
                marginBottom: 5,
            },
        },
        localization: _localization,
        getRowId: (row) => row.departmentId,
        mantineTableContainerProps: {
            style: { maxHeight: height, minHeight: height },
        },
        enableStickyHeader: true,
        onRowSelectionChange: setRowSelection,
        mantineTableBodyCellProps: ({ row }) => ({
            style: styleTableMantine,
        }),
        mantineToolbarAlertBannerProps: false
            ? { color: "red", children: "Lỗi tải dữ liệu !" }
            : undefined,

        mantinePaginationProps: {
            showRowsPerPage: true,
            withEdges: true,
            radius: "xl",
            size: "lg",
            rowsPerPageOptions: ["20", "50", "100"],
        },
        paginationDisplayMode: "pages",
        enableColumnPinning: true,
        mantineTableProps: {
            striped: false,
        },
        mantineTableBodyRowProps: ({ row }) => ({
            onClick: row.getToggleSelectedHandler(),
            sx: { cursor: "pointer" },
        }),
    });
    useEffect(() => {
        const headerHeight = headerRef.current?.offsetHeight || 0;
        const handleResize = () => {
            setHeight(window.innerHeight - (165 + headerHeight));
        };

        handleResize(); // Set initial height
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [height]);
    useEffect(() => {
        fetchData();
    }, [pagination]);
    const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
        option,
    }) => (
        <Group gap="sm">
            <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
        </Group>
    );
    // Sử dụng debounce để trì hoãn việc gọi API
    const debouncedDataItemCode = useDebouncedCallback((value: string) => {
        if (value.length >= 3) {
            DataItemCode(value); // Gọi API với từ khóa tìm kiếm
        }
    }, 500);
    return (
        <Box>
            <LoadingOverlayCustom visible={visible} />
            <div ref={headerRef} style={{ width: "100%", marginBottom: "10px" }}>
                <Flex justify={"space-between"} w={"100%"}>
                    <_breadcrumb></_breadcrumb>
                    <Button
                        leftSection={
                            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                        }
                        onClick={() => exportDataExcel()}
                    >
                        Export Excel
                    </Button>
                </Flex>
                <Grid>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Input
                            placeholder="Nhập tìm kiếm"
                            key={form.key("keySearch")}
                            type="text"
                            leftSection={<IconSearch size={"20"} color="#15aabf" />}
                            onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                    await fetchData();
                                }
                            }}
                            {...form.getInputProps("keySearch")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            placeholder="Nhập mã ngành"
                            data={dataCatSegment2b?.map((item) => ({
                                label: item.label,
                                value: item.value,
                            }))}
                            leftSection={<IconBriefcase color="#15aabf" />}
                            searchable
                            clearable
                            {...form.getInputProps("MaNganh")}
                            nothingFoundMessage="Không tìm thấy dữ liệu !"
                            onClick={() => {
                                if (dataCatSegment2b.length === 0) {
                                    fetchDataCatSegment2b();
                                }
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            placeholder="Nhập mã loại"
                            data={dataCatSegment3c?.map((item) => ({
                                label: item.label,
                                value: item.value,
                            }))}
                            leftSection={<IconPackage color="#15aabf" />}
                            searchable
                            clearable
                            nothingFoundMessage="Không tìm thấy dữ liệu !"
                            {...form.getInputProps("MaLoai")}
                            onClick={() => {
                                if (dataCatSegment3c.length === 0) {
                                    fetchDataCatSegment3c();
                                }
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            placeholder="Nhập mã nhóm"
                            data={dataCatSegment5e}
                            leftSection={<IconFolders color="#15aabf" />}
                            searchable
                            clearable
                            {...form.getInputProps("MaNhom")}
                            onClick={() => {
                                if (dataCatSegment5e.length === 0) {
                                    getCatSegment5e();
                                }
                            }}
                            nothingFoundMessage="Không tìm thấy dữ liệu !"
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            placeholder="Nhập mã hoặc tên hãng sản xuất"
                            data={dataBrand}
                            leftSection={<IconBuildingFactory color="#15aabf" />}
                            searchable
                            clearable
                            {...form.getInputProps("MaHangSx")}
                            onClick={() => {
                                if (dataBrand.length === 0) {
                                    fetchDataBrand();
                                }
                            }}
                            nothingFoundMessage="Không tìm thấy dữ liệu !"
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            key={form.key("invCode")}
                            size="sm"
                            placeholder="Mã kho"
                            searchable
                            clearable
                            data={dataInvCode}
                            leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
                            onClick={() => {
                                if (dataInvCode.length === 0) {
                                    DataInvCode();
                                }
                            }}
                            {...form.getInputProps("invCode")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            key={form.key("itemCode")}
                            size="sm"
                            placeholder="Mã sản phẩm"
                            clearable
                            searchable
                            data={dataItemCode.map((x) => x.value)} // Hiển thị kết quả từ API
                            //   value={search.itemCode}
                            renderOption={renderMultiSelectOption}
                            leftSection={<IconBarcode size={20} color="#15aabf" />}
                            // onSearchChange={(value) => {
                            //   if (value.length >= 3) {
                            //     DataItemCode(value); // Gọi API với từ khóa tìm kiếm
                            //   }
                            // }}
                            onSearchChange={(value) => {
                                debouncedDataItemCode(value); // Sử dụng debounce
                            }}
                            // onChange={(value) => {
                            //   handleChangeSearchValue(value, "itemCode");
                            // }}
                            {...form.getInputProps("itemCode")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <DatePickerInput
                            type="default"
                            key={form.key("FromDate")}
                            leftSection={<IconTimeDuration15 color="#15aabf" />}
                            size="sm"
                            placeholder="Từ ngày"
                            locale="vi"
                            valueFormat="DD/MM/YYYY"
                            {...form.getInputProps("FromDate")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <DatePickerInput
                            type="default"
                            key={form.key("ToDate")}
                            leftSection={<IconTimeDuration15 color="#15aabf" />}
                            size="sm"
                            placeholder="Đến ngày"
                            locale="vi"
                            valueFormat="DD/MM/YYYY"
                            {...form.getInputProps("ToDate")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Input
                            placeholder="Từ tuổi tồn"
                            key={form.key("FromTuoiTon")}
                            leftSection={<IconRulerMeasure size={"20"} color="#15aabf" />}
                            type="number"
                            {...form.getInputProps("FromTuoiTon")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Input
                            placeholder="Đến tuổi tồn"
                            key={form.key("ToTuoiTon")}
                            leftSection={<IconRulerMeasure size={"20"} color="#15aabf" />}
                            type="number"
                            {...form.getInputProps("ToTuoiTon")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Button
                            color="blue"
                            variant="outline"
                            onClick={async () => {
                                await fetchData();
                            }}
                        >
                            Tìm kiếm
                        </Button>
                    </Grid.Col>
                </Grid>
            </div>
            <MantineReactTable table={table} />
        </Box>
    );
};

export default InventoryAge;
